import React from 'react';
import { Loader2 } from 'lucide-react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullScreen = false, label = 'Loading...' }) => {
  const content = (
    <div className="spinner-container">
      <Loader2 className="spinner-icon" size={32} />
      <span className="spinner-label">{label}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="spinner-fullscreen">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
